import { getActiveENV } from '@utils';
import sensors from 'sa-sdk-javascript';

export function  sensorsInit () {
    if (getActiveENV() === ''){
        sensors.init({
            server_url: 'https://gaodun.datasink.sensorsdata.cn/sa?project=default&token=b9ea8de774df405c',
            name: 'gtrs',
            debug_mode: false,
            debug_mode_upload: false,
            heatmap: {
                clickmap: 'default',
                scroll_notice_map: 'default'
            }
        });
        sensors.quick('autoTrack',{
            platform:'gtrs-pc'
        });
    }
}

export function bindEvents(key: string, data: any) {
	
    if (getActiveENV() === '') {
        setTimeout(() => {
            sensors.track(key, {...data});
        }, 500);
    }
}